/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 55
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/beachbody/Commerce%20DR/implementation/web)
 */
import * as amplitude from '@amplitude/analytics-browser'

export type Environment = 'production' | 'development'

export const ApiKey: Record<Environment, string> = {
  production: '1d0ded647159f1fa94847060270f1c3b',
  development: 'b9bfe48d4c966d111fe95010d6199537',
}

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '55',
    branch: 'main',
    source: 'web',
    versionId: '9615b5b5-babd-434d-a0aa-24381089abff',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
}

export interface LoadOptionsBase {
  disabled?: boolean
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment
  client?: { configuration?: BrowserOptions }
}
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions }
}
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient }
}

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance

export interface IdentifyProperties {
  /**
   * The affiliate click id from the user's browser cookie. Set to `EMPTY` if not present.
   */
  'affiliate click id'?: string
  /**
   * Indicates the user's anonymous ID which is a Commercetools GUID that owns a specific cart/order.
   */
  'anonymous id'?: string
  /**
   * Indicates if the user is logged in or not. Possible values: `logged in` or `logged out`.
   */
  'auth status'?: string
  /**
   * Indicates the user's Commercetools cart ID.
   */
  'cart id'?: string
  /**
   * Indicates if the user has specified that their information should not be sold.
   */
  'do not sell'?: boolean
  /**
   * A list of a user's entitlements.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  entitlements?: string[]
  /**
   * A ten digit random number created when a user first visits the site.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'first visit id'?: number
  /**
   * UNIX timestamp in seconds indicating the time a user first visited the site.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  'first visit time'?: number
  /**
   * An object containing hashed properties.
   */
  hashes?: any
  /**
   * The affiliate click id from the URL query parameter seen on the user's initial visit. Set to `(none)` if not present.
   */
  'initial affiliate click id'?: string
  /**
   * The user's membership state: `SUBSCRIBER` or `NONSUBSCRIBER`.
   */
  'membership state'?: string
  /**
   * The NextDoor click ID.
   */
  ndclid?: string
  /**
   * The domain of the referring site
   */
  referring_domain?: string
  /**
   * A list of a user's roles.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  roles?: string[]
  /**
   * Indicates the country portion of the currently selected site locale. Send as lowercase, e.g. `us` or `ca`.
   */
  'site country'?: string
  /**
   * Indicates the language portion of the currently selected site locale. Send as lowercase, e.g. `en` or `fr`.
   */
  'site language'?: string
  /**
   * SocialLadder ambassador ID. Ingested from the AmbassadorID query parameter.
   */
  'socialladder ambassador id'?: string
  /**
   * The User Agent string of the user's browser.
   */
  'user agent'?: string
  /**
   * Data detected from user agent string via next.js `userAgent` function.
   */
  'user agent data'?: {
    browser?: {
      /**
       * Major browser version detected from user agent string via next.js `userAgent` function.
       */
      major?: string
      /**
       * Browser name detected from user agent string via next.js `userAgent` function.
       */
      name?: string
      /**
       * Full browser version detected from user agent string via next.js `userAgent` function.
       */
      version?: string
    }
    device?: {
      /**
       * Device model detected from user agent string via next.js `userAgent` function.
       */
      model?: string
      /**
       * Device vendor detected from user agent string via next.js `userAgent` function.
       */
      vendor?: string
    }
    engine?: {
      /**
       * Browser rendering engine detected from user agent string via next.js `userAgent` function.
       */
      name?: string
      /**
       * Browser rendering engine version detected from user agent string via next.js `userAgent` function.
       */
      version?: string
    }
    /**
     * Detects if user is a bot as detected from user agent string via next.js `userAgent` function.
     */
    isBot?: boolean
    os?: {
      /**
       * Operating system name detected from user agent string via next.js `userAgent` function.
       */
      name?: string
      /**
       * Operating system version detected from user agent string via next.js `userAgent` function.
       */
      version?: string
    }
    /**
     * Raw user agent string detected via next.js `userAgent` function.
     */
    ua?: string
  }
}

export interface AddPromoCodeProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * A promotional code that, when used by customer during checkout, applies designated discounts to an item or order total amount.
   */
  'promo code': string
  /**
   * Indicates the result of adding a promo code to a cart. Use a commercetools [DiscountCodeState](https://docs.commercetools.com/api/projects/carts#discountcodestate) value.
   */
  'promo code result': string
}

export interface AddToCartProperties {
  /**
   * The monetary value for a given event, e.g. the cost of items added to the cart.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Identifies the currency code (compliant to [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217)) used on the cart/order.
   */
  currency: string
  /**
   * Array of objects representing skus in the cart, order, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  'line items': {
    /**
     * A human readable description of the line item.
     */
    description?: string
    /**
     * Identifies the product that a variant belongs to.
     */
    'product key': string
    /**
     * Identifies the product subtype of a line item, e.g. `Subscription` or `DigitalPurchase`.
     */
    'product subtype'?: string
    /**
     * Identifies the type of product that a variant belongs to, e.g. `Digital` or `Nutrition`.
     */
    'product type': string
    /**
     * Identifies the quantity of a given product variant in a line item.
     */
    quantity: number
    /**
     * Identifies the SKU of the product variant in a line item.
     */
    sku: string
  }[]
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface CreateAccountProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface EnterLeadWheelProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface OpenCartFlyoutProperties {
  /**
   * Array of objects representing skus in the cart, order, etc.
   */
  'line items': any[]
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface OpenChatProperties {
  /**
   * Indicates if a chat conversation is new.
   */
  'is new conversation': boolean
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface RemoveFromCartProperties {
  /**
   * Array of objects representing skus in the cart, order, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  'line items': {
    /**
     * A human readable description of the line item.
     */
    description?: string
    /**
     * Identifies the product that a variant belongs to.
     */
    'product key': string
    /**
     * Identifies the product subtype of a line item, e.g. `Subscription` or `DigitalPurchase`.
     */
    'product subtype'?: string
    /**
     * Identifies the type of product that a variant belongs to, e.g. `Digital` or `Nutrition`.
     */
    'product type': string
    /**
     * Identifies the quantity of a given product variant in a line item.
     */
    quantity: number
    /**
     * Identifies the SKU of the product variant in a line item.
     */
    sku: string
  }[]
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface SelectCtaProperties {
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface SelectNavCtaProperties {
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface SelectPencilBannerCtaProperties {
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface SelectRailCtaProperties {
  /**
   * Indicates the numeric position of a CTA within a list of CTAs. Use the number 1 for the first CTA in the list. Use the number 0 for CTAs that are related to the list but not within it, e.g. a "See All" link in a rail.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'cta position': number
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * A unique human-readable identifier for a rail.
   */
  'rail slug': string
}

export interface SelectStickyFooterCtaProperties {
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface SetPasswordProperties {
  /**
   * The error code returned by the API or client validation. This is an optional property that should only be sent if the user encountered an error.
   */
  'error code'?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * Success is all successful submits, server error is any error response from the API, client error is any form field validation/UI error.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | success, server error, client error |
   */
  result: 'success' | 'server error' | 'client error'
}

export interface StartConversationProperties {
  /**
   * Indicates the unique ID for a chat conversation.
   */
  'conversation id': string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface SubmitEmailAddressProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * Indicates the status of a user account after they provide their email address.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new, existing, profile conflict |
   */
  'submit email result': 'new' | 'existing' | 'profile conflict'
}

export interface SubmitOrderProperties {
  /**
   * Indicates the state of the "Same as shipping address" checkbox. NOTE: this does NOT indicate if the shipping and billing addresses are exact matches.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | checked, not checked, not shown |
   */
  'billing same as shipping': 'checked' | 'not checked' | 'not shown'
  /**
   * The error code returned by the API or client validation. This is an optional property that should only be sent if the user encountered an error.
   */
  'error code'?: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * Success is all successful submits, server error is any error response from the API, client error is any form field validation/UI error.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | success, server error, client error |
   */
  result: 'success' | 'server error' | 'client error'
}

export interface UpdateQuantityProperties {
  /**
   * Array of objects representing skus in the cart, order, etc.
   */
  'line items': any[]
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface ViewAffiliateStorefrontProperties {
  /**
   * The LoudCrowd ambassador ID from the `lc_ambassador_id` query parameter seen on affiliate storefront pages powered by LoudCrowd. Set to `unknown` if not present.
   */
  'ambassador id': string
  /**
   * The LoudCrowd customer id from the Base64 decoded `ambassador id`.
   */
  'loudcrowd customer id': string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewCartPageProperties {
  /**
   * Array of objects representing skus in the cart, order, etc.
   */
  'line items': any[]
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewCategoryPageProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewCheckoutPageProperties {
  /**
   * The total monetary value of the cart, including all taxes, shipping amounts, discounts, etc. NOTE: shipping/taxes may not have been calculated yet.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'cart total': number
  /**
   * Identifies the currency code (compliant to [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217)) used on the cart/order.
   */
  currency: string
  /**
   * Array of objects representing skus in the cart, order, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  'line items': {
    /**
     * A human readable description of the line item.
     */
    description?: string
    /**
     * Identifies the product that a variant belongs to.
     */
    'product key': string
    /**
     * Identifies the product subtype of a line item, e.g. `Subscription` or `DigitalPurchase`.
     */
    'product subtype'?: string
    /**
     * Identifies the type of product that a variant belongs to, e.g. `Digital` or `Nutrition`.
     */
    'product type': string
    /**
     * Identifies the quantity of a given product variant in a line item.
     */
    quantity: number
    /**
     * Identifies the SKU of the product variant in a line item.
     */
    sku: string
  }[]
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewCommunityPageProperties {
  /**
   * For the "**view community page**" event, this value is either "logged out" or a value from the `sl-view` query parameter, e.g. "challenges", "rewards", "community", "chat", "notifications", "settings", and "dashboard" if `sl-view` is empty and the user is logged in.
   */
  section: string
}

export interface ViewCreateAccountPageProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewLandingPageProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewOfferPageProperties {
  /**
   * Describes the items being offered on the page.
   */
  offer: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewOrderConfirmationPageProperties {
  /**
   * Identifies the currency code (compliant to [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217)) used on the cart/order.
   */
  currency: string
  /**
   * Everything after the @ in the customer email set on the order. Used for filtering in cases like domain-specifiic discounts (Amazon extras, etc)
   */
  'customer email domain': string
  /**
   * Indicates if an order was placed by a new or existing user. Example values: `NewUser` or `ExistingUser`
   */
  'customer flow': string
  /**
   * A list of unique discount keys that have been applied to line items in a user's cart/order. NOTE: These refer to discounts that may have been achieved through one or more means, e.g. promo codes, cart discounts, etc. Send an empty array if no discounts have been applied.
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  discounts: string[]
  /**
   * Array of objects representing skus in the cart, order, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  'line items': {
    /**
     * A human readable description of the line item.
     */
    description?: string
    /**
     * Identifies the product that a variant belongs to.
     */
    'product key': string
    /**
     * Identifies the product subtype of a line item, e.g. `Subscription` or `DigitalPurchase`.
     */
    'product subtype'?: string
    /**
     * Identifies the type of product that a variant belongs to, e.g. `Digital` or `Nutrition`.
     */
    'product type': string
    /**
     * Identifies the quantity of a given product variant in a line item.
     */
    quantity: number
    /**
     * Identifies the SKU of the product variant in a line item.
     */
    sku: string
  }[]
  /**
   * Unique order identifier assigned by commerce system upon successful submission of order.
   */
  'order id': string
  /**
   * The total amount for the order, including all taxes, shipping amounts, discounts, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'order total': number
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The preferred method of payment selected by the customer during checkout, options include "card" or "paypal".
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, paypal, apple pay |
   */
  'payment method': 'card' | 'paypal' | 'apple pay'
  /**
   * A list of promotional codes that, when used by customer during checkout, apply designated discounts to an item or order total amount. Send an empty array if no promo codes have been applied.
   */
  'promo codes': any[]
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * Used to track referrals of orders.
   *
   * * `none` if no partner id exists on the order
   *
   * * `new partner` if partner id exists on the order
   *
   * * `existing partner` if user already had a non-corporate partner before placing the order
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | none, existing partner, new partner |
   */
  'referral type': 'none' | 'existing partner' | 'new partner'
  /**
   * Specifies the delivery method selected for the order in cases where physical products are included on the order. Default when no shippables are included should be `N/A`
   */
  'shipping method': string
  /**
   * The commercetools store for the order.
   */
  store: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
  /**
   * An array of all web source codes accumulated by a user for an order, commonly used for DR campaign/affiliate attribution. For tracking, we should split on `*|*` and send as an array of strings. If no web source codes exist, do not send anything.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'web source codes'?: string[]
}

export interface ViewOtherPageProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewProductDetailPageProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  'product key': string
  'product subtype': string
  'product type': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * Product selections derived from query parameters in a page URL. Expressed as an array with a single object containing all relevant product selections from the query parameters. Expressed as an empty array if there are no relevant parameters.
   */
  'url product selections': any[]
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface ViewUpsellPageProperties {
  /**
   * Describes the items being offered on the page.
   */
  offer: string
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export interface CtaProperties {
  /**
   * The target url for a button or hyperlink displayed to the user, where the url might redirect to a particular page or other content, and might include other parameters, such as an ICID.
   */
  'cta url'?: string
  /**
   * Describes the UI module that a given event was triggered by.
   */
  module?: string
}

export interface GlobalProperties {
  /**
   * The segment of the page url between the domain name and query string parameters.
   */
  'page path': string
  /**
   * The slug of the specific page being displayed, to support any number of expected pages variations for a given page type, depending on channel, campaign, and flow variation.
   */
  'page slug': string
  /**
   * Complete page URL including query string parameters.
   */
  'page url': string
}

export interface OrderProperties {
  /**
   * Identifies the currency code (compliant to [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217)) used on the cart/order.
   */
  currency: string
  /**
   * Everything after the @ in the customer email set on the order. Used for filtering in cases like domain-specifiic discounts (Amazon extras, etc)
   */
  'customer email domain': string
  /**
   * Indicates if an order was placed by a new or existing user. Example values: `NewUser` or `ExistingUser`
   */
  'customer flow': string
  /**
   * A list of unique discount keys that have been applied to line items in a user's cart/order. NOTE: These refer to discounts that may have been achieved through one or more means, e.g. promo codes, cart discounts, etc. Send an empty array if no discounts have been applied.
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  discounts: string[]
  /**
   * Array of objects representing skus in the cart, order, etc.
   */
  'line items': any[]
  /**
   * Unique order identifier assigned by commerce system upon successful submission of order.
   */
  'order id': string
  /**
   * The total amount for the order, including all taxes, shipping amounts, discounts, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  'order total': number
  /**
   * The preferred method of payment selected by the customer during checkout, options include "card" or "paypal".
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | card, paypal, apple pay |
   */
  'payment method': 'card' | 'paypal' | 'apple pay'
  /**
   * A list of promotional codes that, when used by customer during checkout, apply designated discounts to an item or order total amount. Send an empty array if no promo codes have been applied.
   */
  'promo codes': any[]
  /**
   * Used to track referrals of orders.
   *
   * * `none` if no partner id exists on the order
   *
   * * `new partner` if partner id exists on the order
   *
   * * `existing partner` if user already had a non-corporate partner before placing the order
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | none, existing partner, new partner |
   */
  'referral type': 'none' | 'existing partner' | 'new partner'
  /**
   * Specifies the delivery method selected for the order in cases where physical products are included on the order. Default when no shippables are included should be `N/A`
   */
  'shipping method': string
  /**
   * The commercetools store for the order.
   */
  store: string
  /**
   * An array of all web source codes accumulated by a user for an order, commonly used for DR campaign/affiliate attribution. For tracking, we should split on `*|*` and send as an array of strings. If no web source codes exist, do not send anything.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  'web source codes'?: string[]
}

export interface ScreenViewsProperties {
  /**
   * The segment of the page url after the domain and path, containing only the query string parameters
   */
  'query params'?: string
  /**
   * The value of the "code" query string parameter, if present in the URL.
   */
  'web source code'?: string
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties
  }
}

export class AddPromoCode implements BaseEvent {
  event_type = 'add promo code'

  constructor(public event_properties: AddPromoCodeProperties) {
    this.event_properties = event_properties
  }
}

export class AddToCart implements BaseEvent {
  event_type = 'add to cart'

  constructor(public event_properties: AddToCartProperties) {
    this.event_properties = event_properties
  }
}

export class CreateAccount implements BaseEvent {
  event_type = 'create account'

  constructor(public event_properties: CreateAccountProperties) {
    this.event_properties = event_properties
  }
}

export class EnterLeadWheel implements BaseEvent {
  event_type = 'enter lead wheel'

  constructor(public event_properties: EnterLeadWheelProperties) {
    this.event_properties = event_properties
  }
}

export class OpenCartFlyout implements BaseEvent {
  event_type = 'open cart flyout'

  constructor(public event_properties: OpenCartFlyoutProperties) {
    this.event_properties = event_properties
  }
}

export class OpenChat implements BaseEvent {
  event_type = 'open chat'

  constructor(public event_properties: OpenChatProperties) {
    this.event_properties = event_properties
  }
}

export class RemoveFromCart implements BaseEvent {
  event_type = 'remove from cart'

  constructor(public event_properties: RemoveFromCartProperties) {
    this.event_properties = event_properties
  }
}

export class SelectCta implements BaseEvent {
  event_type = 'select cta'

  constructor(public event_properties: SelectCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SelectNavCta implements BaseEvent {
  event_type = 'select nav cta'

  constructor(public event_properties: SelectNavCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SelectPencilBannerCta implements BaseEvent {
  event_type = 'select pencil banner cta'

  constructor(public event_properties: SelectPencilBannerCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SelectRailCta implements BaseEvent {
  event_type = 'select rail cta'

  constructor(public event_properties: SelectRailCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SelectStickyFooterCta implements BaseEvent {
  event_type = 'select sticky footer cta'

  constructor(public event_properties: SelectStickyFooterCtaProperties) {
    this.event_properties = event_properties
  }
}

export class SetPassword implements BaseEvent {
  event_type = 'set password'

  constructor(public event_properties: SetPasswordProperties) {
    this.event_properties = event_properties
  }
}

export class StartConversation implements BaseEvent {
  event_type = 'start conversation'

  constructor(public event_properties: StartConversationProperties) {
    this.event_properties = event_properties
  }
}

export class SubmitEmailAddress implements BaseEvent {
  event_type = 'submit email address'

  constructor(public event_properties: SubmitEmailAddressProperties) {
    this.event_properties = event_properties
  }
}

export class SubmitOrder implements BaseEvent {
  event_type = 'submit order'

  constructor(public event_properties: SubmitOrderProperties) {
    this.event_properties = event_properties
  }
}

export class UpdateQuantity implements BaseEvent {
  event_type = 'update quantity'

  constructor(public event_properties: UpdateQuantityProperties) {
    this.event_properties = event_properties
  }
}

export class ViewAffiliateStorefront implements BaseEvent {
  event_type = 'view affiliate storefront'

  constructor(public event_properties: ViewAffiliateStorefrontProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCartPage implements BaseEvent {
  event_type = 'view cart page'

  constructor(public event_properties: ViewCartPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCategoryPage implements BaseEvent {
  event_type = 'view category page'

  constructor(public event_properties: ViewCategoryPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCheckoutPage implements BaseEvent {
  event_type = 'view checkout page'

  constructor(public event_properties: ViewCheckoutPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCommunityPage implements BaseEvent {
  event_type = 'view community page'

  constructor(public event_properties: ViewCommunityPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewCreateAccountPage implements BaseEvent {
  event_type = 'view create account page'

  constructor(public event_properties: ViewCreateAccountPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewLandingPage implements BaseEvent {
  event_type = 'view landing page'

  constructor(public event_properties: ViewLandingPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewOfferPage implements BaseEvent {
  event_type = 'view offer page'

  constructor(public event_properties: ViewOfferPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewOrderConfirmationPage implements BaseEvent {
  event_type = 'view order confirmation page'

  constructor(public event_properties: ViewOrderConfirmationPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewOtherPage implements BaseEvent {
  event_type = 'view other page'

  constructor(public event_properties: ViewOtherPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewProductDetailPage implements BaseEvent {
  event_type = 'view product detail page'

  constructor(public event_properties: ViewProductDetailPageProperties) {
    this.event_properties = event_properties
  }
}

export class ViewUpsellPage implements BaseEvent {
  event_type = 'view upsell page'

  constructor(public event_properties: ViewUpsellPageProperties) {
    this.event_properties = event_properties
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> }

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * add promo code
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/add%20promo%20code)
   *
   * Tracks when a user adds a promo code during checkout.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  addPromoCode(
    properties: AddPromoCodeProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddPromoCode(properties), options);
  }

  /**
   * add to cart
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/add%20to%20cart)
   *
   * Tracks the click/select of a button that adds item(s) to your cart
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  addToCart(
    properties: AddToCartProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddToCart(properties), options);
  }

  /**
   * create account
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/create%20account)
   *
   * This event tracks when a user submits the form to create a new account.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  createAccount(
    properties: CreateAccountProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreateAccount(properties), options);
  }

  /**
   * enter lead wheel
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/enter%20lead%20wheel)
   *
   * This event tracks when a user enters the lead wheel which will get them assigned to a new partner.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  enterLeadWheel(
    properties: EnterLeadWheelProperties,
    options?: EventOptions,
  ) {
    return this.track(new EnterLeadWheel(properties), options);
  }

  /**
   * open cart flyout
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/open%20cart%20flyout)
   *
   * Event that captures when a user opens the cart flyout during their session on the website.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. line items)
   * @param options Amplitude event options.
   */
  openCartFlyout(
    properties: OpenCartFlyoutProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenCartFlyout(properties), options);
  }

  /**
   * open chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/open%20chat)
   *
   * Event the captures when a user opens the chat window.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. is new conversation)
   * @param options Amplitude event options.
   */
  openChat(
    properties: OpenChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenChat(properties), options);
  }

  /**
   * remove from cart
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/remove%20from%20cart)
   *
   * Tracks when a line item is removed from the cart before completing the order.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. line items)
   * @param options Amplitude event options.
   */
  removeFromCart(
    properties: RemoveFromCartProperties,
    options?: EventOptions,
  ) {
    return this.track(new RemoveFromCart(properties), options);
  }

  /**
   * select cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/select%20cta)
   *
   * This event tracks when a user selects a call-to-action (CTA) on our platform.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. cta url)
   * @param options Amplitude event options.
   */
  selectCta(
    properties: SelectCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectCta(properties), options);
  }

  /**
   * select nav cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/select%20nav%20cta)
   *
   * This event tracks when a user selects a CTA button in the main navigation menu.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. cta url)
   * @param options Amplitude event options.
   */
  selectNavCta(
    properties: SelectNavCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectNavCta(properties), options);
  }

  /**
   * select pencil banner cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/select%20pencil%20banner%20cta)
   *
   * This event tracks when users select a call-to-action (CTA) in a pencil banner.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. cta url)
   * @param options Amplitude event options.
   */
  selectPencilBannerCta(
    properties: SelectPencilBannerCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectPencilBannerCta(properties), options);
  }

  /**
   * select rail cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/select%20rail%20cta)
   *
   * Event to track when a user interacts with an item within a rail.
   *
   * @param properties The event's properties (e.g. cta position)
   * @param options Amplitude event options.
   */
  selectRailCta(
    properties: SelectRailCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectRailCta(properties), options);
  }

  /**
   * select sticky footer cta
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/select%20sticky%20footer%20cta)
   *
   * This event tracks when a user selects a call-to-action (CTA) in a  sticky footer.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. cta url)
   * @param options Amplitude event options.
   */
  selectStickyFooterCta(
    properties: SelectStickyFooterCtaProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectStickyFooterCta(properties), options);
  }

  /**
   * set password
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/set%20password)
   *
   * This event tracks when a new user sets their password after completing an order as a guest.
   *
   * @param properties The event's properties (e.g. error code)
   * @param options Amplitude event options.
   */
  setPassword(
    properties: SetPasswordProperties,
    options?: EventOptions,
  ) {
    return this.track(new SetPassword(properties), options);
  }

  /**
   * start conversation
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/start%20conversation)
   *
   * Event that captures when a user has started a chat conversation.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. conversation id)
   * @param options Amplitude event options.
   */
  startConversation(
    properties: StartConversationProperties,
    options?: EventOptions,
  ) {
    return this.track(new StartConversation(properties), options);
  }

  /**
   * submit email address
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/submit%20email%20address)
   *
   * This event tracks when a user inputs and submits their email address on an email capture screen, which is a screen in any purchase or registration flow where users are prompted to enter their email address.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  submitEmailAddress(
    properties: SubmitEmailAddressProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubmitEmailAddress(properties), options);
  }

  /**
   * submit order
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/submit%20order)
   *
   * This event is triggered when a user clicks the place order button, regardless of the outcome of that call.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. billing same as shipping)
   * @param options Amplitude event options.
   */
  submitOrder(
    properties: SubmitOrderProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubmitOrder(properties), options);
  }

  /**
   * update quantity
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/update%20quantity)
   *
   * Tracks when a user updates the quantity of a line item in their cart.
   *
   * @param properties The event's properties (e.g. line items)
   * @param options Amplitude event options.
   */
  updateQuantity(
    properties: UpdateQuantityProperties,
    options?: EventOptions,
  ) {
    return this.track(new UpdateQuantity(properties), options);
  }

  /**
   * view affiliate storefront
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20affiliate%20storefront)
   *
   * This event tracks when a user views an affiliate storefront page powered by LoudCrowd.
   *
   * @param properties The event's properties (e.g. ambassador id)
   * @param options Amplitude event options.
   */
  viewAffiliateStorefront(
    properties: ViewAffiliateStorefrontProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewAffiliateStorefront(properties), options);
  }

  /**
   * view cart page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20cart%20page)
   *
   * Event that captures when a user views the cart page during their session on the website.
   *
   * @param properties The event's properties (e.g. line items)
   * @param options Amplitude event options.
   */
  viewCartPage(
    properties: ViewCartPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCartPage(properties), options);
  }

  /**
   * view category page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20category%20page)
   *
   * **This event tracks when a user views a particular category page, depending on the specific url used**
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  viewCategoryPage(
    properties: ViewCategoryPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCategoryPage(properties), options);
  }

  /**
   * view checkout page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20checkout%20page)
   *
   * This event tracks when a user views the checkout page during their session.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. cart total)
   * @param options Amplitude event options.
   */
  viewCheckoutPage(
    properties: ViewCheckoutPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCheckoutPage(properties), options);
  }

  /**
   * view community page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20community%20page)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  viewCommunityPage(
    properties: ViewCommunityPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCommunityPage(properties), options);
  }

  /**
   * view create account page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20create%20account%20page)
   *
   * This event tracks when a user views the create account page/screen
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  viewCreateAccountPage(
    properties: ViewCreateAccountPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewCreateAccountPage(properties), options);
  }

  /**
   * view landing page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20landing%20page)
   *
   * This event tracks when a user views a particular landing/sell page.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  viewLandingPage(
    properties: ViewLandingPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewLandingPage(properties), options);
  }

  /**
   * view offer page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20offer%20page)
   *
   * This event tracks when a user views an offer page on our platform
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. offer)
   * @param options Amplitude event options.
   */
  viewOfferPage(
    properties: ViewOfferPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewOfferPage(properties), options);
  }

  /**
   * view order confirmation page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20order%20confirmation%20page)
   *
   * This event is triggered when a customer successfully completes an order and receives a confirmation. It provides valuable data on the number of orders being placed and can be used to track conversion rates and measure the success of marketing campaigns
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. currency)
   * @param options Amplitude event options.
   */
  viewOrderConfirmationPage(
    properties: ViewOrderConfirmationPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewOrderConfirmationPage(properties), options);
  }

  /**
   * view other page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20other%20page)
   *
   * This event tracks when a user views a page that doesn't match one of the other page view events. It is the default/fallback custom page view event.
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  viewOtherPage(
    properties: ViewOtherPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewOtherPage(properties), options);
  }

  /**
   * view product detail page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20product%20detail%20page)
   *
   * Event that captures when a user views a product detail page.
   *
   * @param properties The event's properties (e.g. page path)
   * @param options Amplitude event options.
   */
  viewProductDetailPage(
    properties: ViewProductDetailPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewProductDetailPage(properties), options);
  }

  /**
   * view upsell page
   *
   * [View in Tracking Plan](https://data.amplitude.com/beachbody/Commerce%20DR/events/main/latest/view%20upsell%20page)
   *
   * This event tracks when a user views the upsell page
   *
   * Owner: Jared Thigpen
   *
   * @param properties The event's properties (e.g. offer)
   * @param options Amplitude event options.
   */
  viewUpsellPage(
    properties: ViewUpsellPageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewUpsellPage(properties), options);
  }
}

export const ampli = new Ampli()

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions

export type BrowserClient = amplitude.Types.BrowserClient
export type BaseEvent = amplitude.Types.BaseEvent
export type IdentifyEvent = amplitude.Types.IdentifyEvent
export type GroupEvent = amplitude.Types.GroupIdentifyEvent
export type Event = amplitude.Types.Event
export type EventOptions = amplitude.Types.EventOptions
export type Result = amplitude.Types.Result
